import { useContext, useEffect, useState } from 'react';
import DrawerIcon from '../assets/svg/header/drawericon.svg';
import ShoppingCart from '../assets/svg/shopping_cart.svg';
import CompanyLogo from '../assets/header_logo.png';
import Badge from '@mui/material/Badge';
import { AuthContext } from '../pages/RootPage';
import { useNavigate } from 'react-router-dom';

export default function DetailsHeader() {
	const { toggleDrawer } = useContext(AuthContext);
	const navigate = useNavigate();
	const [badgeCount, setbadgeCount] = useState(0);
	const [logo, setlogo] = useState(CompanyLogo);

	useEffect(() => {
		getCompanyInfo();
		getCartCount();
		window.addEventListener('productQtyChange', getCartCount);
		return () => {
			window.removeEventListener('productQtyChange', getCartCount);
		};
	}, []);

	const getCompanyInfo = () => {
		const value = localStorage.getItem('companyInfo');
		if (value) {
			let companyInfo = JSON.parse(value);
			const Logo = (companyInfo.logo && companyInfo.logo !== "") ? companyInfo.logo : CompanyLogo;
			setlogo(Logo);
		}
	};

	const getCartCount = () => {
		const cart = localStorage.getItem('cartItems');
		if (!cart) {
			setbadgeCount(0);
		} else {
			const cartItems = JSON.parse(cart);
			setbadgeCount(cartItems?.customerCartItems?.length || 0);
		}
	};

	return (
		<div style={{ position: 'sticky', top: 0, zIndex: 999, backgroundColor: '#ffffff', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.6rem 12px' }}>
			<div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={() => toggleDrawer()}>
				<img src={DrawerIcon} style={{ width: 20, height: 20 }} alt='Menu' />
			</div>

			<div
				style={{
					display: "flex",
					flex: 1,
					justifyContent: "center",
					alignItems: "center",
					cursor: "pointer",
					paddingInline: "8px",
				}}
				onClick={() => navigate("/")}
			>
				<img src={logo || CompanyLogo} height="auto" width={140} alt="Store Logo" style={{ cursor: "pointer", maxWidth: "100%", maxHeight: "38px", objectFit: "contain" }} />
			</div>

			<div
				style={{ cursor: 'pointer', padding: '4px 6px', display: 'flex', alignItems: 'center' }}
				onClick={() => navigate('/Cart')}
				title='Cart'
			>
				<Badge badgeContent={badgeCount} color='warning'>
					<img src={ShoppingCart} style={{ width: 24, height: 24 }} alt='Cart' />
				</Badge>
			</div>
		</div>
	);
}






